import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { FaCircle, FaRegUserCircle } from "react-icons/fa";
import { RiTaskFill } from "react-icons/ri";
import { SiTask } from "react-icons/si";
const TaskCard = ({ issue, columnId }) => {
  const {
    fields: { summary, issuetype, parent },
    key,
  } = issue;
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({
    id: issue.id,
    data: {
      type: "task",
      issue: { ...issue, columnId },
    },
  });
  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };
  if (isDragging) {
    return (
      <div className="bg-[#25252a] rounded-lg p-4 w-[380px] h-[120px] opacity-30"></div>
    );
  }
  return (
    <div
      className="bg-zinc-900 rounded-lg  p-4 text-gray-400"
      ref={setNodeRef}
      style={style}
      {...listeners}
      {...attributes}
    >
      <div className="flex gap-2 flex-col">
        <div className="flex items-center justify-between">
          <div className="inline-flex items-center gap-2">
            <RiTaskFill className="text-green-500" size={12} />
            <span className="text-sm">{key}</span>
          </div>
          <span>
            <FaRegUserCircle className="text-white" size={18} />
          </span>
        </div>
        <div className="flex gap-3">
          <span className="h-5 w-5 inline-flex items-center justify-center rounded-full bg-blue-600">
            <SiTask size={12} className="text-white" />
          </span>
          <h3 className="text-base font-semibold">{summary}</h3>
        </div>
        <div className="flex items-center justify-between mt-2 gap-2">
          <div className="px-1.5 py-0.5 rounded-2xl border inline-flex items-center gap-1">
            <span>
              <FaCircle
                className={`${
                  issuetype.name === "Story"
                    ? "text-green-500"
                    : "text-orange-500"
                }`}
                size={12}
              />
            </span>
            <span className="text-sm font-semibold">{issuetype.name}</span>
          </div>
          {issuetype.name === "Story" && parent?.fields?.summary && (
            <span className="px-1.5 py-0.5 border rounded-xl bg-black truncate max-w-[200px] inline-block font-semibold text-base">
              {parent?.fields?.summary}
            </span>
          )}
        </div>
      </div>
    </div>
  );
};

export default TaskCard;
